import { render, staticRenderFns } from "./NavBarAdmin.vue?vue&type=template&id=f645106a&scoped=true&"
import script from "./NavBarAdmin.vue?vue&type=script&lang=js&"
export * from "./NavBarAdmin.vue?vue&type=script&lang=js&"
import style0 from "./NavBarAdmin.vue?vue&type=style&index=0&id=f645106a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f645106a",
  null
  
)

export default component.exports